import { FC, useEffect, useState } from "react";
import { Box, Card, Divider, FormControl, FormControlLabel, FormLabel, IconButton, Input, ListItem, ListItemAvatar, Radio, RadioGroup } from "@mui/material";
import styled from "@emotion/styled";
import RemoveIcon from "@mui/icons-material/Delete";


const Container = styled(Card)`
    padding: 10px;
    margin-bottom: 10px;
`


interface ModuleItemProps {
    module: any;
    index: number;
    pushModules: boolean;
    onRemoveModule: (randomKey: string) => void;
    onSetModulesToPush: (
        modules: any
    ) => void;
    mode: 'add' | 'check'
}

const ModuleItem: FC<ModuleItemProps> = ({
    module,
    index,
    pushModules,
    onRemoveModule,
    onSetModulesToPush,
    mode
}) => {
    const [name, setName] = useState<string>('')
    const [width, setWidth] = useState<number | ''>('')
    const [depth, setDepth] = useState<number | ''>('')
    const [height, setHeight] = useState<number | ''>('')
    const [description, setDescription] = useState<string>('')
    const [moduleType, setModuleType] = useState<'left' | 'right' | 'middle' | 'corner' | 'solo' | null>(null)


    useEffect(() => {
        if (!pushModules) return

        const newModule = {
            image: module.image,
            name: name,
            width: width,
            depth: depth,
            height: height,
            description: description,
            moduleType: moduleType,
        }
        onSetModulesToPush(newModule)
    }, [
        pushModules,
        name,
        width,
        depth,
        height,
        description,
        moduleType,
        module.image,
        module.randomKey,
        onSetModulesToPush,
    ])


    return (
        <Container key={index} sx={mode === 'check' ? { display: 'none' } : {}}>
            <Box key={index}>
                <ListItem
                    secondaryAction={
                        <IconButton
                            onClick={() => {
                                if (!module.randomKey) return;
                                onRemoveModule(module.randomKey)
                            }}
                            color='error'
                        >
                            <RemoveIcon />
                        </IconButton>
                    }
                    disablePadding
                >
                    <ListItem>
                        <ListItemAvatar>
                            <img
                                alt={module.name}
                                style={{
                                    width: 100,
                                    height: 100,
                                    marginRight: '10px',
                                    objectFit: 'contain'
                                }}
                                src={URL.createObjectURL(module.image[0])}
                            />
                        </ListItemAvatar>
                        <Box>
                            <Input
                                placeholder="Nazwa"
                                sx={{ width: '100%' }}
                                value={name}
                                onChange={(e) => setName(e.target.value.toUpperCase())}
                            />
                            <Box>
                                <Input
                                    type="number"
                                    sx={{
                                        mr: 1,
                                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                            WebkitAppearance: 'none',
                                            margin: 0,
                                        },
                                        '& input[type=number]': {
                                            MozAppearance: 'textfield',
                                        },
                                    }}
                                    value={width}
                                    onChange={(e) => setWidth(Number(e.target.value))}
                                    placeholder="szer"
                                    onWheel={e => (e.target as HTMLInputElement).blur()}
                                />
                                <Input
                                    type="number"
                                    sx={{
                                        mr: 1,
                                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                            WebkitAppearance: 'none',
                                            margin: 0,
                                        },
                                        '& input[type=number]': {
                                            MozAppearance: 'textfield',
                                        },
                                    }}
                                    value={depth}
                                    onChange={(e) => setDepth(Number(e.target.value))}
                                    placeholder="gł"
                                    onWheel={e => (e.target as HTMLInputElement).blur()}
                                />
                                <Input
                                    type="number"
                                    value={height}
                                    onChange={(e) => setHeight(Number(e.target.value))}
                                    placeholder="wys"
                                    onWheel={e => (e.target as HTMLInputElement).blur()}
                                    sx={{
                                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                            WebkitAppearance: 'none',
                                            margin: 0,
                                        },
                                        '& input[type=number]': {
                                            MozAppearance: 'textfield',
                                        },
                                    }}
                                />
                            </Box>
                            <Input
                                value={description}
                                onChange={(e) => setDescription(e.target.value.toUpperCase())}
                                placeholder="Opis"
                                multiline
                                sx={{ width: '100%' }}
                            />
                            <FormControl sx={{ mt: 2 }}>
                                <FormLabel id="moduleTypeGroup">TYP</FormLabel>
                                <RadioGroup
                                    aria-labelledby="moduleTypeGroup"
                                    name="radio-buttons-group"
                                    row
                                    value={moduleType}
                                >
                                    <FormControlLabel
                                        onClick={() => setModuleType('left')}
                                        value="left"
                                        control={<Radio />}
                                        label="LEWY" />
                                    <FormControlLabel
                                        onClick={() => setModuleType('middle')}
                                        value="middle"
                                        control={<Radio />}
                                        label="WEWNĘTRZNY" />
                                    <FormControlLabel
                                        onClick={() => setModuleType('right')}
                                        value="right"
                                        control={<Radio />}
                                        label="PRAWY" />
                                    <FormControlLabel
                                        onClick={() => setModuleType('corner')}
                                        value="corner"
                                        control={<Radio />}
                                        label="NAROŻNIK" />
                                    <FormControlLabel
                                        onClick={() => setModuleType('solo')}
                                        value="solo"
                                        control={<Radio />}
                                        label="SOLO" />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    </ListItem>
                </ListItem>
                <Divider sx={{ m: 1 }} />
            </Box>
        </Container>
    )
}

export default ModuleItem;